import { OfferRepository, Offer, OfferNotFoundError, OfferFactory } from '@/Domain/Offer'
import { Offer as VuexOffer } from '@/Infrastructure/Store/AuctionB/Offer'
import store from '@/Infrastructure/Store'

export class VuexOfferRepository implements OfferRepository {
  private _factory: OfferFactory<VuexOffer>

  constructor (factory: OfferFactory<VuexOffer>) {
    this._factory = factory
  }

  byBatchId (batchId: string): Offer {
    const offers = store.getters['auctionb/offers']
    if (!offers || offers.length === 0) {
      throw new OfferNotFoundError(`Batch ${batchId} has no offer`)
    }
    const offer = offers.find((current: VuexOffer) => current.batchId === batchId)
    if (!offer) {
      throw new OfferNotFoundError(`Batch ${batchId} has no offer`)
    }
    return this._factory.makeOffer(offer)
  }
}
